import { useCallback, useState } from 'react';
import { useAddress, useContract } from '@thirdweb-dev/react';
import { useAsyncFn } from 'react-use';
import { useConfig } from '@app/config';
import { formatUnits, parseUnits } from 'ethers/lib/utils';
import { useQueryClient } from '@tanstack/react-query';
import { QueryKeys } from '@app/constants/queryKeys';
import { useSupportedChain } from '@app/hooks/other/useSupportedChain';
import { useUserXKimAllocationToPlugin } from '@app/hooks/nft/useUserXKimAllocationToPlugin';

export function useUnstake() {
  const address = useAddress();
  const queryClient = useQueryClient();
  const [state, setState] = useState<{
    amount: string;
  }>({
    amount: ''
  });

  const handleAmountChange = useCallback((val: string) => {
    setState(prev => ({
      ...prev,
      amount: val
    }));
  }, []);

  const chainId = useSupportedChain()?.chainId;

  const config = useConfig();

  const { contract: xKimContract } = useContract(config?.CONTRACTS.X_KIM);

  const [{ loading: deallocating }, deallocate] = useAsyncFn(async () => {
    if (!xKimContract || !address) {
      return;
    }

    const res = await xKimContract?.call('deallocate', [
      config?.CONTRACTS.NFT_MARKETPLACE,
      parseUnits(state.amount, 18),
      []
    ]);

    await queryClient.invalidateQueries([
      QueryKeys.GET_USER_X_KIM_ALLOCATION_TU_PLUGIN
    ]);

    return res;
  }, [xKimContract, address, state.amount, config]);

  const { data: currentAllocation, isLoading } =
    useUserXKimAllocationToPlugin();

  const resetStateValues = useCallback(() => {
    setState({
      amount: ''
    });
  }, []);

  return {
    state,
    handleAmountChange,
    deallocate,
    deallocating,
    resetStateValues,
    currentAllocation,
    isLoading
  };
}
